export default {
    teams: 'api/teams',
    challenges: 'api/challenges',
    tasks: {
        status: 'api/tasks/status',
        get: 'api/tasks',
    },
    settings: 'api/settings',
};
